import { cn } from 'lib/utils';
import { TONE_CLASSES } from './pillTone';

export type PillTone = 'added' | 'removed' | 'neutral';

const SEMANTIC_TONE = { added: 'emerald', removed: 'rose', neutral: 'zinc' } as const;

/** One diff value, toned added/removed/neutral (CA6) — shares its color map with `ActionPill` (I4). */
const Pill = ({ tone, children }: { tone: PillTone; children: string }) => (
  <span
    className={cn(
      'inline-flex h-[22px] items-center rounded-full px-2.5 text-[12px] font-medium',
      TONE_CLASSES[SEMANTIC_TONE[tone]],
      tone === 'removed' && 'line-through'
    )}
  >
    {tone === 'added' ? `+ ${children}` : children}
  </span>
);

export default Pill;
